import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PRICE_PLAN_URL } from "../config/siteUrls";

const PricePlan = () => {
  const { search } = useLocation();

  useEffect(() => {
    window.location.replace(`${PRICE_PLAN_URL}${search}`);
  }, [search]);

  return null;
};

export default PricePlan;
